import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface EventFirstDisplay {
	evCd: string;
	evNm: string;
	dspSid1: string;
	dspSid2: string;
	dspSid3: string;
	dspSid4: string;
}

/** ```
 * 행사 첫번째 전시 코드 조회
 *   `/pkg/event/{evCd}/first-display`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const key = "useEventFirstDisplay";
const getPath = (evCd: string): string | null => {
	if (!evCd) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event/${evCd}/first-display`;
};

/** ```
 * 행사 첫번째 전시 코드 조회
 *   `/pkg/event/{evCd}/first-display`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const useEventFirstDisplay = (evCd: string, options?: Partial<UseQueryOptions<Response<EventFirstDisplay>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(evCd)],
		queryFn: () => useConfigureAxios({url: getPath(evCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		placeholderData: {
			body: {
				evCd: "",
				evNm: "",
				dspSid1: "",
				dspSid2: "",
				dspSid3: "",
				dspSid4: "",
			},
		},
		...options,
	});

export default useEventFirstDisplay;
export {getPath, key};
export type {EventFirstDisplay};
